// i18n area 'system' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO (lingua SORGENTE, regola
// 2026-08-03). Glossario di sezione: framsal (delega), hlutverk (ruolo), heimild
// (permesso), sækni/andsækni (affinità/anti-affinità), skilríki (certificato),
// einkalykill/dreifilykill (chiave privata/pubblica), útgefandi (emittente),
// eigind (attributo LDAP), vörulykill (product key), áskrift (sottoscrizione);
// restano invariati realm, scope, bind, keystore, enrollment, audit, principal,
// CN/SAN/PEM/CRL/CA, backoff, crash loop, decider.
// Sidecar anti-stantie: ../meta/system.is-IS.meta.json.
import type { enUS } from './system'

export const isIS: typeof enUS = {
  diagnostics: {
    title: 'Greining',
    subtitle: 'Hvað er að, versta fyrst — sama linsa og tvirt diagnose',
    reload: 'Endurhlaða',
    loadError: 'Ekki tókst að lesa greininguna',
    exportBundle: 'Flytja út pakka',
    exportError: 'Ekki tókst að búa til pakkann',
    noProblem: 'Ekkert vandamál á skoðuðum svæðum',
    nothingInspected: 'EKKERT var skoðað — þetta er ekki heilbrigðisvottorð',
    inspected: 'Skoðuð',
    notInspected: 'EKKI skoðuð',
    localHint: 'Staðbundin svæði hnútsins (systemd-einingar, journal) lesast aðeins úr CLI: tvirt diagnose --area local — leiðin þegar API svarar ekki.',
    thresholds: 'misheppnuð verk innan {hours} klst., heartbeat seinna en {seconds} s',
    severity: {
      critical: 'Alvarlegt',
      warning: 'Viðvörun',
      unknown: 'Óþekkt'
    }
  },
  explorer: {
    title: 'Skoða auðlindir',
    root: 'Rót',
    empty: 'Engin auðlind í þessu scope',
    previewHint: 'Veldu hlut til að sjá forskoðun hans',
    open: 'Opna',

    // Il deep-link ?scope= delle liste CRUD (round #109), dall'esplora (#143).
    openScoped: 'Opna listann í þessu scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-sniðmát',
      ct: 'CT',
      ctTemplate: 'CT-sniðmát',
      app: 'App',
      overlayNetwork: 'Overlay-net',
      networkService: 'Netþjónusta',
      fabric: 'Fabric',
      subnet: 'Undirnet',
      storage: 'Geymslu-pool',
      disk: 'Diskur',
      catalogFile: 'Katalógskrá',
      ociRegistry: 'OCI-registry',
      ociImage: 'OCI-mynd',
      cephCluster: 'Ceph-klasi',
      backupDestination: 'Áfangastaður afritunar',
      user: 'Notandi',
      group: 'Hópur',
      role: 'Hlutverk',
      credential: 'Aðgangsupplýsingar',
      tag: 'Merki',
      proximityRule: 'Nálægðarregla'
    }
  },
  tags: {
    title: 'Merki',
    empty: 'Engin merki',
    add: 'Bæta við merki',
    remove: 'Fjarlægja',
    name: 'Merki',
    value: 'Gildi',
    save: 'Vista',
    saveError: 'Ekki tókst að vista merkin',
    loadError: 'Ekki tókst að sækja orðaforða merkjanna',
    noVocabulary: 'Ekkert merki tiltækt fyrir þessa tegund auðlindar',

    // A single-valued tag already set answers 409: the replacement is always
    // explicit — never an implicit substitution (design, ratified 2026-07-27).
    overwrite: 'Skipta út núverandi gildi',

    // Sistema > Tag, the vocabulary surface.
    createTitle: 'Búa til merki',
    editTitle: 'Breyta merki',
    nameHint: 'Bókstafir, tölustafir, punktar, bandstrik og undirstrik — hvorki „:“ né „/“; forskeytið tvirt- er frátekið fyrir vettvanginn',
    cardinality: 'Fjöldi gilda',
    cardinalitySingle: 'Eitt gildi',
    cardinalityMultiple: 'Fleiri gildi',
    cardinalityHint: 'Með einu gildi biður endurúthlutun merkisins um að skipta því út',
    autoCreate: 'Sjálfvirk stofnun gilda',
    autoCreateOn: 'Við úthlutun',
    autoCreateOff: 'Aðeins yfirlýst',
    autoCreateHint: 'Virkt: að úthluta nýju gildi býr það til. Óvirkt: aðeins yfirlýstum gildum er úthlutað',
    values: 'Gildi',
    noValues: 'Ekkert gildi yfirlýst',
    addValue: 'Bæta við gildi',
    duplicateValue: 'Tvítekið gildi',
    kinds: 'Tegundir auðlinda',
    kindsAll: 'Allar',
    kindsPlaceholder: 'Allar',
    kindsHint: 'Skildu eftir autt til að leyfa allar merkjanlegar tegundir auðlinda',
    systemChip: 'Kerfi',
    deleteCascade: 'Fjarlægja einnig úthlutanirnar',
    deleteCascadeHint: 'Merki sem er enn úthlutað einhverri auðlind er hafnað: með þessum valkosti hverfa gildin og allar úthlutanir ásamt merkinu.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Búa til scope',
    editTitle: 'Endurnefna scope',
    path: 'Slóð',
    segment: 'Liður',
    segmentHint: 'Lágstafir, tölustafir og bandstrik (DNS-1123)',
    parent: 'Foreldri',
    rootChip: 'Rót',
    preview: 'Nýtt scope',
    pickLabel: 'Scope',
    pickHint: 'Þar sem hluturinn býr í tré klasans — rótin eða vDC innan hennar.',
    ociCache: 'OCI-skyndiminni (yfirtaka)',
    appEphemeral: 'Hverful app-pool (yfirtaka)',
    inherit: 'Erfa',
    inheritsFrom: 'Erfir frá',
    inheritsCluster: 'Erfir sjálfgefna klasagildið',
    inheritsNone: 'Erfir — ekkert virkt pool',
    failoverProtection: 'Vernd í skertum rekstri',
    networkWeight: 'Netvægi',
    networkCeil: 'Netþak (Mbps)',
    protectionProtected: 'Varið',
    protectionExpendable: 'Fórnanlegt í skertum rekstri',
    protectionDefault: 'Sjálfgefið klasagildi'
  },

  // Sistema > Informazioni (round #124, 2026-07-31): versioni piattaforma
  // nella flotta (al massimo due mid-upgrade), componenti per nodo, manuale
  // PDF servito localmente e card licenza inglobata.
  sysinfo: {
    summary: 'Útgáfur vettvangsins í klasanum, íhlutir hvers hnúts, stjórnunarhandbók og leyfi.',
    platformTitle: 'TVirt-vettvangurinn',
    platformSubtitle: 'Útgáfur athugaðar á hnútum klasans',
    versionOnNodes: '{version} á {n} hnútum',
    versionOnOneNode: '{version} á 1 hnút',
    mixedVersions: 'Fleiri en ein útgáfa vettvangsins í klasanum — aðeins væntanlegt meðan uppfærsla er í gangi (í mesta lagi tvær).',
    tooManyVersions: 'Fleiri en tvær útgáfur vettvangsins í klasanum — það er aldrei væntanlegt, ekki einu sinni í uppfærslu: athugaðu hnútana hér fyrir neðan.',
    unreportedNodes: 'Enn engin útgáfuskýrsla frá: {nodes}',
    noVersionsYet: 'Enginn hnútur hefur enn gefið upp útgáfur sínar.',
    nodesUnavailable: 'Hnútalistinn er ekki sýnilegur með þínum heimildum — ekki er hægt að sýna útgáfur vettvangsins.',
    colNode: 'Hnútur',
    manualTitle: 'Stjórnunarhandbók',
    manualSubtitle: 'Staðbundið eintak, borið fram af þessum klasa',
    manualBody: 'Öll TVirt-handbókin á PDF, borin fram beint af vettvanginum — einnig tiltæk í air-gapped umhverfum.',
    manualLink: 'Stjórnunarhandbók (PDF)',
    apiExplorerTitle: 'API-skoðari',
    apiExplorerSubtitle: 'OpenAPI-samningurinn, skoðanlegur',
    apiExplorerBody: 'Heildar-OpenAPI-samningur vettvangsins — hver leið, hvert skema og hver svarkóði — skoðanlegur úr vafranum, borinn fram í gegnum þennan hnút.',
    apiExplorerLink: 'Skoða API',
    kubeTitle: 'Kubernetes-samhæfni',
    kubeSubtitle: 'kubectl og tól þess, fyrir framan innbyggða API-ið',
    kubeBody: 'TVirt KubeCompat varpar Pod, Deployment, Service, nafnrýmum, hnútum og atburðum yfir í Kubernetes-mállýskuna — aðeins lestur, auk eyðingar Deployment. Hvert kall fer í gegnum innbyggða API-ið með þínum heimildum: notaðu app token sem bearer í kubeconfig.',
    kubeEndpoint: 'Endapunktur fyrir kubectl',
    kubeStatusActive: 'Virkt — Kubernetes {version}',
    kubeStatusMissing: 'Ekki uppsett á þessum hnút (pakkinn trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Uppsett en svarar ekki — athugaðu eininguna trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Athuga…'
  },

  // Licensing (round 2026-07-29): la pagina della licenza a sottoscrizione.
  licensing: {
    title: 'Leyfi klasans',
    subtitle: 'Áskriftarleyfi — í mesta lagi eitt á klasa',
    absentTitle: 'Ekkert leyfi skráð',
    absentBody:
      'Án gilds leyfis neitar klasinn að ræsa nýjar sýndarvélar (kveiktu VM-arnar haldast kveiktar). Skráðu vörulykilinn sem fylgdi áskriftinni.',
    registerButton: 'Skrá leyfi',
    removeButton: 'Fjarlægja leyfi',
    state: {
      ok: 'Gilt',
      limitExceeded: 'Farið yfir mörk',
      expired: 'Útrunnið'
    },
    productKeyLabel: 'Vörulykill',
    basisLabel: 'Grunnur markanna',
    basis: {
      concurrentVms: 'Samtímis kveiktar VM',
      physicalCores: 'Efnislegir kjarnar (klasinn alls)'
    },
    limitLabel: 'Mörk',
    usageLabel: 'Núverandi notkun',
    usageOf: '{used} af {limit}',
    usagePartial: 'hlutasumma — {n} hnútur/hnútar án athugaðrar CPU-grannfræði',
    usageUnknown: 'ekki mælanlegt í augnablikinu',
    expiresLabel: 'Gildislok',
    neverExpires: 'aldrei',
    registeredLabel: 'Skráð',
    gateNote:
      'Með leyfi sem vantar, er útrunnið eða yfir mörkum neitar klasinn að ræsa NÝJAR sýndarvélar. Kveiktu VM-arnar haldast kveiktar og HA-endurræsingar verða ekki fyrir áhrifum.',
    devStage:
      'Þróunarstig: vörulykillinn er samþykktur eins og hann er ásamt mörkunum sem hér eru yfirlýst; löggilding með undirrituðum lykli kemur í síðari útgáfu.',
    dialogTitle: 'Skrá leyfi',
    dialogExpiresHelp: 'Autt = leyfið rennur aldrei út',
    dialogSubmit: 'Skrá',
    dialogError: 'Ekki tókst að skrá leyfið.',
    removeTitle: 'Fjarlægja leyfi',
    removeBody:
      'Klasinn verður ÁN LEYFIS: nýjar sýndarvélar neita að ræsa þar til þú skráir nýtt. Kveiktu VM-arnar haldast kveiktar.',
    removeConfirm: 'Fjarlægja',
    removeError: 'Ekki tókst að fjarlægja leyfið.'
  },
  rbac: {
    tabRoles: 'Hlutverk',
    tabGrants: 'Framsöl',
    rolesTitle: 'Hlutverk',
    createRoleTitle: 'Búa til hlutverk',
    editRoleTitle: 'Breyta hlutverki',
    nameHint: 'Lágstafir, tölustafir og bandstrik; forskeytið tvirt- er frátekið',
    systemChip: 'Kerfi',
    permissions: 'Heimildir',
    permissionsPlaceholder: 'Bæta við heimild…',
    includedRoles: 'Innifalin hlutverk',
    includedRolesPlaceholder: 'Bæta við hlutverki…',
    grantsTitle: 'Framsöl',
    createGrantTitle: 'Búa til framsal',
    principal: 'Principal',
    principalKind: 'Tegund principal',
    principalUser: 'Notandi',
    principalGroup: 'Hópur',
    role: 'Hlutverk',
    grantRight: 'Framsal',
    grantRightChip: 'Má framselja',
    grantRightLabel: 'Með framsalsrétti (viðtakandinn má sjálfur framselja þetta hlutverk áfram)',
    effective: 'Virkt',
    notEffective: 'Ekki virkt',
    createdAt: 'Búið til',
    scopeHint: '/slóð nákvæm, /slóð/* endurkvæm — framsölin festast við tengda rót (/* er ekki framseljanlegt)'
  },
  groups: {
    title: 'Hópar',
    createTitle: 'Búa til hóp',
    nameHint: 'Lágstafir, tölustafir og bandstrik; einkvæmt innan scope',
    members: 'Meðlimir',
    membersTitle: 'Meðlimir',
    membersPlaceholder: 'Bæta við notanda…',
    noMembers: 'Enginn meðlimur',
    realmMappings: 'Realm-varpanir',
    realmMappingsTitle: 'Realm-varpanir',
    realmMappingsHint:
      'Hverju þessi hópur samsvarar í hverju ytra realmi. Aðildin er lesin úr directory-inu við innskráningu: directory-hópur sem enginn varpar hér er hunsaður, og hreiðrun er ekki leyst upp — hana þarf að fletja út directory-megin.',
    realm: 'Realm',
    externalGroup: 'Ytri hópur',
    addRealmMapping: 'Bæta við vörpun',
    removeRealmMapping: 'Fjarlægja vörpun',
    noRealmMappings: 'Engin realm-vörpun',

    // Dialog di creazione a sezioni (round realm-wizard, 2026-08-03): Generale
    // più la superficie di mappatura coi realm esterni, con l'empty state
    // parlante.
    sectionGeneral: 'Almennt',
    mappingsNoRealms: 'Ekkert ytra realm stillt — vörpunaryfirborðið opnast um leið og realm er til.',
    mappingsNoRealmsLink: 'Opna flipann Realm og SSO',

    // L'obbligo MFA imposto dal gruppo (round #178 metà B): OR puro — un
    // gruppo può solo AGGIUNGERE l'obbligo, mai toglierlo.
    mfaRequired: 'MFA-skylda',
    mfaRequiredChip: 'Krefst MFA',
    mfaNotRequiredChip: 'Engin skylda',
    mfaRequiredHint:
      'Hreint OR: hópur getur BÆTT skyldu annars þáttar á meðlimi sína — líka á ytri auðkenni, gegnum realm-varpanir — aldrei tekið hana af. Gildir frá næstu innskráningu: opnum setum er ekki lokað.'
  },
  users: {
    title: 'Notendur',
    createTitle: 'Búa til notanda',
    editTitle: 'Breyta notanda',
    username: 'Notandanafn',
    usernameHint: 'Lágstafir, tölustafir, punktar og bandstrik',
    displayName: 'Birtingarnafn',
    enabled: 'Virkur',
    state: 'Staða',
    enabledChip: 'Virkur',
    disabledChip: 'Óvirkur',
    lockedChip: 'Læstur',
    password: 'Lykilorð',
    passwordSetChip: 'Sett',
    mustChangeChip: 'Þarf að breyta',
    initialPassword: 'Upphafslykilorð',
    initialPasswordHint: 'Notandinn þarf að breyta því við fyrstu innskráningu',
    lastLogin: 'Síðasta innskráning',
    neverLoggedIn: 'Aldrei skráður inn',
    setPasswordTitle: 'Setja lykilorð',
    setPasswordHint: 'Stjórnsýsluleg útskipting — krefst lykilorðsins þíns (sudo-hamur) og skyldar notandann til að breyta því við næstu innskráningu.',
    operatorPassword: 'Lykilorðið þitt',
    unlock: 'Aflæsa aðgangnum',
    revokeTitle: 'Afturkalla setur',
    revokeBody: 'Öllum virkum setum þessa notanda er slitið samstundis.',
    revokeIncludeTokens: 'Afturkalla líka app-tóka',
    revokeConfirm: 'Afturkalla',

    // Dialog standard (round #156): dettagli completi, tab account/sicurezza.
    tabAccount: 'Aðgangur',
    tabSecurity: 'Öryggi',
    usernameImmutableHint: 'Notandanafnið er auðkenni aðgangsins — fest við stofnun',
    groups: 'Hópar',
    noGroups: 'Enginn hópur',
    mustChangePassword: 'Skyldubundin lykilorðsbreyting',
    failedAttempts: 'Misheppnaðar innskráningartilraunir',
    lockedUntil: 'Læstur til',

    // Identity tabs (2026-08-03): Sistema > Utenti è diventata una sezione a
    // tab sul modello di /system/rbac — utenti, gruppi, realm esterni.
    tabUsers: 'Notendur',
    tabGroups: 'Hópar',
    tabRealms: 'Realm og SSO',
    tabMfa: 'MFA',

    // Tab MFA (task #178): la vista del secondo fattore. Metà A — la tabella
    // per-utente su users.yaml; metà B (round contract, ratifiche 2026-08-04)
    // — il verdetto efficace con la provenienza, gli enrollment esterni con
    // lo stato orfano e i gruppi che impongono l'obbligo.
    mfa: {
      title: 'Annar þáttur (MFA)',
      methodsTitle: 'Tiltækar aðferðir',
      methodsSubtitle: 'Það sem þessi uppsetning kann að sannreyna sem annan þátt',
      methodsError: 'Ekki tókst að sækja aðferðaskrána',
      builtinChip: 'Innbyggð',
      enrollableChip: 'Enrollment í TVirt',
      delegatedChip: 'Stýrt utanhúss',
      state: 'Staða',
      stateActive: 'Virkur',
      statePending: 'Bíður enrollment',
      stateNone: 'Ekkert enrollment',
      required: 'MFA-skylda',
      requiredChip: 'Skylda',
      notRequiredChip: 'Ekki skylda',
      enrolledAt: 'Enrollment þann',
      enrolledMethods: 'Skráðar aðferðir',
      noMethods: 'Ekkert enrollment',
      codesRemaining: 'Endurheimtarkóðar eftir',
      resetTitle: 'Núllstilla annan þáttinn',
      resetHint:
        'Enrollment-ið og allir endurheimtarkóðarnir eru núllstilltir: við næstu innskráningu gerir notandinn enrollment upp á nýtt. MFA-skyldan stendur óbreytt — kerfisstjóri setur aldrei leyndarmál, hann núllstillir það aðeins.',
      resetConfirm: 'Núllstilla',
      resetError: 'Ekki tókst að núllstilla annan þáttinn',
      empty: 'Enn enginn stýrður notandi — aðgangarnir birtast hér um leið og þeir eru til, hver með stöðu annars þáttar síns.',

      // Metà B (round #178): provenienza del verdetto efficace, enrollment
      // esterni con lo stato orfano, gruppi che impongono l'obbligo.
      viaSelf: 'Persónulegt',
      viaSelfHint: 'Persónulega framlag aðgangsins (flagg hans) — eini hlutinn sem blýanturinn breytir.',
      viaGroupHint: 'Skylda erfð frá þessum hópi: að taka persónulega flaggið af leysir notandann ekki — gripið er inn í á hópnum, í Hópar-flipanum.',
      subject: 'Auðkenni',
      lastSeenAt: 'Síðasta staðfesting',
      enrollmentPending: 'Í bið',
      orphanChip: 'Munaðarlaust',
      orphanDirectoryMiss: 'Auðkennið er ekki lengur í directory-inu',
      orphanRealmRemoved: 'Realmið var fjarlægt úr TVirt',
      orphanedAt: 'Munaðarlaust frá',
      directoryUuid: 'UUID í directory-inu',
      externalTitle: 'Ytri enrollment',
      externalEmpty: 'Enn ekkert ytra enrollment — það fæðist við fyrstu innskráningu directory-auðkennis með MFA-skyldu.',
      orphanHelp:
        'Munaðarlaust enrollment eyðist aldrei af sjálfu sér: það er öryggisefni — það situr eftir fyrir audit og, birtist auðkennið aftur í directory-inu, finnur það þáttinn sinn á ný. Eina útgönguleiðin er stjórnsýslulega núllstillingin.',
      visibilityHint: 'Ytri enrollment búa við rót klasans: þau sér aðeins sá sem hefur user.read á öllu trénu.',
      orphanResetHint:
        'Munaðarlausa röðin er fjarlægð endanlega: enginn gerir tilkall til hennar lengur. Birtist auðkennið aftur í directory-inu gerir það enrollment upp á nýtt.',
      enforcingTitle: 'Hópar sem krefjast MFA',
      enforcingSubtitle:
        'Akkeri skyldunnar fyrir ytri auðkenni er hópurinn: realm-varpanir hans segja til um hvaða directory-hóp hún nær til. Ytra enrollment-ið fæðist við fyrstu innskráningu skyldaða notandans.',
      enforcingEmpty: 'Enginn hópur krefst MFA — skyldan er virkjuð á hópnum, úr Hópar-flipanum.',
      enforcingError: 'Ekki tókst að sækja hópana sem krefjast MFA'
    }
  },
  realms: {
    title: 'Auðkenningar-realm',
    createTitle: 'Búa til realm',
    editTitle: 'Breyta realmi',
    name: 'Realm',
    nameHint: 'Lénið sem notendurnir skrifa á eftir @ (example.com) — óbreytanlegt eftir stofnun',
    nameImmutableHint: 'Nafn realmsins er stimplað í hverja setu og hverja audit-línu sem hefur nokkurn tíma nefnt það — að endurnefna það myndi endurskrifa söguna',
    kind: 'Tegund',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC og SAML koma með næstu roundum — í dag er realm LDAPv3-directory',

    // Semi-wizard di creazione (round realm-wizard, 2026-08-03): le card dei
    // tipi del passo 1 — ldap vivo, oidc/saml card in roadmap (mai un form
    // senza un backend dietro).
    kindCategory: 'Tegund realms',
    kindSelectHint: 'Veldu tegund directory-sins sem þetta realm mun auðkenna á.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Notandanafn og lykilorð sannreynd með bindi á LDAPv3-directory — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on úr vafranum framselt til OpenID Connect identity provider — kemur með næstu roundum.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on fyrirtækja með SAML 2.0-fullyrðingum — kemur með næstu roundum.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Virkt',
    urls: 'Þjónar directory-sins',
    urlsHint: 'Eitt ldap://- eða ldaps://-URL í hverri línu (1–8), reynd í röð — failover, aldrei jöfnun álags',
    startTls: 'StartTLS',
    verifyCertificate: 'Sannreyna skilríkið',
    cleartextWarning: 'Án ldaps:// eða StartTLS fer bind-lykilorðið yfir netið í hreinum texta — ásættanlegt á tilraunastofu, aldrei í rekstri.',
    noVerifyWarning: 'Ósannreynd TLS-seta auðkennir engan: slökktu aðeins á sannprófuninni gagnvart directory-i sem þú getur ekki lagað.',
    caCertificate: 'CA-skilríki (PEM)',
    caCertificateHint: 'Valfrjálst CA-bundle fest fyrir TLS/StartTLS-handshake þessa realms; autt fjarlægir það',
    caCertificatePinned: 'Fest',
    connectTimeout: 'Tímamörk (sekúndur)',
    connectTimeoutHint: 'Frestur á hvert URL fyrir tengingu og beiðni (1–60); renni hann út er næsta URL reynt',
    bindDn: 'Bind DN',
    bindDnHint: 'Þjónustureikningurinn sem framkvæmir notandaleitina; autt = nafnlaust search bind (hafnað af AD)',
    anonymousBind: 'Nafnlaust search bind',
    bindCredential: 'Bind-lykilorð (keystore)',
    bindCredentialHint: 'usernamePassword-færsla í keystore með bind-lykilorðinu — leyndarmálið býr aldrei á realminu',
    bindCredentialNone: 'Ekkert (nafnlaust bind)',
    bindCredentialEmpty: 'Engin usernamePassword-færsla í keystore — búðu eina til í Kerfi > Aðgangsupplýsingar fyrir bind-lykilorðið.',
    baseDn: 'Base DN',
    baseDnHint: 'Undirtréð sem notandaleitin hefst frá (DC=example,DC=com)',
    userFilter: 'Notandasía',
    userFilterHint: '%u er skipt út fyrir staðbundna hluta innskráningarinnar, með RFC 4515-escape; directory sem eru ekki AD vilja yfirleitt (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf-eigind',
    memberOfAttributeHint: 'Lesin aðeins einu sinni, við innskráningu — óvarpaðir hópar eru hunsaðir, hreiðrun er ekki leyst upp',
    uuidAttribute: 'UUID-eigind',
    uuidAttributeHint: 'Óbreytanlega UUID-ið í realminu (objectGUID á AD, entryUUID á OpenLDAP) — stimplað í audit-ið við hlið notandi@realm',
    displayNameAttribute: 'Eigind birtingarnafns',
    displayNameAttributeHint: 'Notuð til að heilsa notandanum; vanti hana er innskráningarnafnið notað',
    sudoHint: 'Skriftir á realm eru sudo-varðar: realm er inngangsdyr inn í vettvanginn',
    deleteBody: 'Hópavarpanir realmsins fara með því; seturnar sem það auðkenndi lifa til gildisloka — eytt realm hleypir einfaldlega engum inn lengur.',
    tabConnection: 'Tenging',
    tabDirectory: 'Directory',
    testTitle: 'Prófa tengingu',
    testHint: 'Stillingakönnun, aldrei auðkenning: hún tengist, gerir bind með þjónustureikningnum og — með notandanafni — keyrir notandasíuna.',
    testUsername: 'Notandanafn (valfrjálst)',
    testUsernameHint: 'Staðbundinn hluti til að keyra notandasíuna á — 1 samsvörun er heilbrigða svarið',
    testRun: 'Keyra prófun',
    testError: 'Ekki tókst að keyra könnunina',
    testReachable: 'Directory náanlegt, þjónustu-bind samþykkt',
    testUnreachable: 'Directory EKKI náanlegt',
    matchedOne: 'Notandasían fann nákvæmlega 1 færslu — heilbrigða svarið.',
    matchedNone: 'Notandasían fann enga færslu: sían eða base DN er rangt.',
    matchedMany: 'Notandasían fann {count} færslur: hún er ekki valvís, og innskráningar væru tvíræðar (hafnað).',
    mappingsPointer: 'Hverju ytri hópur samsvarar er eiginleiki TVirt-hópsins (realm-varpanir hans): sannleikspunkturinn býr í Hópar-flipanum.',
    mappingsPointerLink: 'Opna Hópar-flipann',
    rootHomeHint: 'Auðkenni ytra realms búa við rót klasans, aldrei í vDC: heimildir eru veittar þar sem þeirra er þörf, með framsölum — á hópnum eða beint á notandanum, nákvæmlega eins og fyrir innfædda.'
  },
  credentials: {
    title: 'Aðgangsupplýsingar',
    createTitle: 'Búa til aðgangsupplýsingar',
    editTitle: 'Breyta aðgangsupplýsingum',
    kind: 'Tegund',
    kindUsernamePassword: 'Notandanafn og lykilorð',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-auðkenni)',
    kindHintUsernamePassword: 'Óbreytanlegt. Fyrir CIFS/SMB-geymslur — mount-reikningurinn sem worker-inn notar leyndarmál hans við mount.',
    kindHintIscsiChap: 'Óbreytanlegt. Fyrir CHAP-auðkenningu iSCSI — notandanafn = CHAP-nafn, leyndarmál = CHAP-leyndarmál.',
    kindHintNvmeDhchap: 'Óbreytanlegt. Fyrir DH-HMAC-CHAP hjá NVMe over Fabrics — leyndarmál = DHHC-1:xx:…-blobbið; notandanafnið er aðeins merkimiði.',
    kindHintCephx: 'Óbreytanlegt. Fyrir Ceph-biðlara — notandanafn = nafn biðlarans (client.…), leyndarmál = base64-lykillinn.',
    kindImmutableHint: 'Tegundin er óbreytanleg eftir stofnun — að breyta henni þýðir nýjar aðgangsupplýsingar.',
    username: 'Notandanafn',
    usernameChap: 'CHAP-nafn',
    usernameNvme: 'Merkimiði',
    usernameCephx: 'Nafn biðlarans',
    usernameHint: 'Valfrjáls reikningur sem leyndarmálið tilheyrir',
    usernameHintChap: 'CHAP-nafnið sem initiator-inn auðkennir sig með',
    usernameHintNvme: 'Ekki notað af flutningnum — frjáls merkimiði fyrir glósurnar þínar',
    usernameHintCephx: 'Nafn cephx-biðlarans — forskeytið client. er þolað',
    secret: 'Leyndarmál',
    secretHint: 'Aðeins skrifað: notað af neytendunum, aldrei sýnt aftur.',
    secretHintNvmeDhchap: 'Aðeins skrifað: DH-HMAC-CHAP-hýsilleyndarmálið á staðlaða forminu DHHC-1:xx:… — notað af neytendunum, aldrei sýnt aftur.',
    secretHintCephx: 'Aðeins skrifað: base64 cephx-lykillinn — notaður af neytendunum, aldrei sýndur aftur.',
    secretEditHint: 'Skildu eftir autt til að breyta ekki leyndarmálinu — að fylla það út snýr því.',
    createdAt: 'Búnar til',
    inUseError: "Vísað er í '{name}' úr stillingum geymslu — aftengdu þær þar fyrst.",
    nameHint: 'Lágstafir, tölustafir og bandstrik (DNS-1123); einkvæmt innan scope',

    // Dialog di sola rotazione (round #156): il segreto non ha mai la matita inline.
    rotateTitle: 'Snúa leyndarmáli',
    rotateHint: 'Aðeins skrifað: nýja leyndarmálið kemur í stað þess geymda — neytendurnir nota það við næsta mount.',

    // Round #159 (PKI): i tab Certificati e CA.
    tabSecrets: 'Leyndarmál',
    tabCertificates: 'Skilríki',
    tabAuthorities: 'Útgefendur skilríkja',
    certificatesTitle: 'Skilríki',
    authoritiesTitle: 'Útgefendur skilríkja',
    caCreateTitle: 'Nýtt CA',
    certCreateTitle: 'Nýtt skilríki',
    caMode: 'Uppruni',
    caModeGenerate: 'Búa til með TVirt',
    caModeImport: 'Flytja inn (lykill + skilríki)',
    certMode: 'Uppruni',
    certModeIssue: 'Gefa út frá CA í keystore',
    certModeImport: 'Flytja inn (lykill + skilríki)',
    issuingCa: 'Útgefandi CA',
    issuingCaHint: 'Skilríkið fæðist í scope CA-sins, með foreldrið skráð',
    noCasHint: 'Ekkert CA í keystore — búðu fyrst til eða flyttu inn eitt í CA-flipanum',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject CA-sins: bókstafir, tölustafir, bil, punktur, undirstrik, bandstrik',
    commonNameCertHint: 'OpenVPN auðkennir biðlarana af CN-inu — haltu því einkvæmu innan hvers CA',
    days: 'Gildistími (dagar)',
    daysCaHint: '1–7300 dagar; 3650 (10 ár) er sjálfgefið',
    daysCertHint: '1–3650 dagar; 365 er sjálfgefið',
    keyType: 'Tegund lykils',
    keyTypeHint: 'EC P-256 er sjálfgefið; RSA fyrir legacy-neytendur',
    usage: 'Notkun',
    usageClient: 'Biðlari (clientAuth)',
    usageServer: 'Þjónn (serverAuth)',
    usageHint: 'Extended key usage sem skilríkið er gefið út fyrir',
    san: 'Önnur nöfn (SAN)',
    sanHint: 'Aðskilin með kommu; bókstaflegar IP-tölur verða IP:-færslur, restin DNS:',
    keyPem: 'Einkalykill (PEM)',
    keyPemHint: 'Aðeins skrifaður: varðveittur í keystore, aldrei sýndur aftur',
    certPem: 'Skilríki (PEM)',
    certPemHint: 'Opinbera skilríkið sem parast við lykilinn',
    certPemCaHint: 'CA-skilríkið sem parast við lykilinn (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Útgefandi',
    parentCa: 'Útgefandi CA',
    parentCaImported: 'Innflutt — gefið út utan TVirt',
    serial: 'Raðnúmer',
    fingerprint: 'Fingrafar (SHA-256)',
    validFrom: 'Gilt frá',
    validUntil: 'Gilt til',
    expiry: 'Gildislok',
    expired: 'Útrunnið',
    expiresInDays: 'Rennur út eftir {days} d.',
    revoked: 'Afturkallað',
    revokedAtLabel: 'Afturkallað þann',
    revokeTitle: 'Afturkalla skilríki',
    revokeAction: 'Afturkalla',
    revokeWarning: 'Afturköllunin er endanleg: raðnúmerið fer í CRL útgefandi CA-sins og hver neytandi sem hafnar afturkölluðum skilríkjum (OpenVPN fremst í flokki) mun vísa þessu frá. Ekkert un-revoke er til.',
    exportPem: 'Flytja út PEM',
    exportChain: 'Flytja út keðju-bundle',
    exportCrl: 'Flytja út CRL',
    materialImmutableHint: 'X.509-efnið er óbreytanlegt — gefðu út aftur eða flyttu inn aftur',
    caInUseError: "'{name}' á enn lifandi útgefin skilríki (eða geymsla vísar í það) — afturkallaðu þau eða eyddu þeim fyrst."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Staðsetning, tiltækileiki og sækni — hvar VM-ar klasans keyra og hvort þær eigi að vera kveiktar',
    loadError: 'Proximity-spjaldið krefst gagnageymslu klasans — staða flotans er ekki náanleg núna',
    config: {
      title: 'Stillingar',
      subtitle: 'Staðsetningarstefna á klasastigi',
      save: 'Vista',
      saveError: 'Stillingunum var hafnað',
      strategy: 'Valaðferð',
      strategy_leastUsedResources: 'Minnst notaðar auðlindir',
      strategy_leastVms: 'Fæstar VM',
      strategy_random: 'Tilviljanakennt',
      strategyLeastUsedResourcesHint: 'Meðal gildra kandídata, hnúturinn með mest nothæft vinnsluminni eftir (athuguð heild − hýsilforði − kveiktar VM), vCPU-skuldbinding sem oddaatkvæði. Löggeng við sömu gögn.',
      strategyLeastVmsHint: 'Meðal gildra kandídata, hnúturinn með fæstar kveiktar VM; jafntefli leyst eftir nafni. Löggeng við sömu gögn.',
      strategyRandomHint: 'Jafndreift tilviljanakennt meðal gildra kandídata.',
      liveness: 'Lífsmarksmörk hnútanna (sekúndur)',
      livenessHint: 'Meðlimur þögull umfram mörkin er ónáanlegur: útilokaður frá staðsetningu og — sé hann ekki í viðhaldi — talinn dauður af HA-deciderinum, sem girðir hann af og endurræsir HA-VM-arnar hans annars staðar.',
      decider: 'HA-decider',
      deciderNone: 'ekki enn kjörinn'
    },
    nodesTitle: 'Hnútar',
    nodesSubtitle: 'Lífsmark og raungeta — nothæft vinnsluminni = heild − grunnur − skuldbundið',
    nodeCol: 'Hnútur',
    stateCol: 'Staða',
    ramCol: 'Vinnsluminni (heild − grunnur − skuldbundið)',
    usableCol: 'Nothæft',
    vmsCol: 'Álag',
    neverSeen: 'aldrei sést',
    freshChip: 'náanlegur',
    staleChip: 'ónáanlegur',
    attestedChip: 'staðfestur slökktur',
    ramFormula: 'heild − grunnur − skuldbundið',
    haTitle: 'Hátiltækileiki',
    haSubtitle: 'VM með HA-flagg eru „alltaf kveiktar“: TVirt endurræsir þær eftir hverja óumbeðna stöðvun — sami hnútur með backoff, annar hnútur þegar þeirra deyr (aðeins deild geymsla).',
    haNone: 'Engin VM ber enn HA-flaggið — virkjaðu það hér eða í nánari upplýsingum VM-arinnar.',
    haVmCol: 'Sýndarvél',
    haStateCol: 'Staða',
    haRestartsCol: 'HA-endurræsingar',
    haLastEventCol: 'Síðasti atburður',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA-breytingunni var hafnað',
    rules: {
      title: 'Sæknireglur',
      createTitle: 'Ný nálægðarregla',
      editTitle: 'Breyta reglu',
      nameHint: 'Lágstafir, tölustafir og bandstrik (DNS-merkimiði)',
      vms: 'Sýndarvélar',
      vmsHint: 'Að minnsta kosti tvær VM — reglan skorðar hvar þær keyra hver gagnvart annarri',
      type: 'Tegund',
      affinity: 'Sækni (saman)',
      antiAffinity: 'Andsækni (aðskildar)',
      typeAffinityHint: 'VM-arnar verða að keyra á SAMA hnút.',
      typeAntiAffinityHint: 'VM-arnar verða að keyra á ÓLÍKUM hnútum — klassíska HA-parið.',
      mode: 'Hamur',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Brot hafna aðgerðinni (ræsing, flutningur, failover) með villu sem segir hvers vegna.',
      modeSoftHint: 'Ósk, aldrei blokkandi: staðsetning í broti heldur áfram með sýnilegri aðvörun.',
      satisfied: 'Staðsetning',
      satisfiedYes: 'virt',
      satisfiedNo: 'brotin',

      // Dialog standard (round #156): le violazioni hanno la loro riga, non un tooltip.
      violations: 'Brot',
      noViolations: 'Engin'
    },
    events: {
      title: 'HA-atburðir',
      subtitle: 'Annáll tiltækileikans — endurræsingar, afgirðingar, failover og heiðarlegu sleppingarnar',
      none: 'Enn ekkert.',
      when: 'Hvenær',
      kind: 'Atburður',
      target: 'Viðfang',
      detail: 'Nánar',
      kindRestarted: 'HA-endurræsing',
      kindGaveUp: 'uppgjöf (crash loop)',
      kindNodeAttested: 'hnútur girtur af',
      kindFailedOver: 'failover',
      kindNoCandidate: 'enginn kandídat',
      kindStorageLocalSkip: 'sleppt (staðbundin geymsla)',
      kindZombieFenced: 'zombie felldur'
    }
  }
}
